import { createFileRoute } from '@tanstack/react-router'
import { AdminGuard } from '@/components/admin-guard'
import { TrackerListView } from '@/features/tracker/TrackerListView'

function ClientTrackerRoute() {
  const { companyId } = Route.useParams()
  return (
    <AdminGuard>
      <TrackerListView admin companyId={companyId} showOrigin embedded />
    </AdminGuard>
  )
}

export const Route = createFileRoute('/clients/$companyId/client-tracker')({ component: ClientTrackerRoute })
